import { cookieDomain, getCookie, setCookie } from "./cookies.js";
import { GOOGLE_SESSION_COOKIE, GOOGLE_SESSION_MAX_AGE_MS, parseGoogleSession, type GoogleSessionDetails } from "./google-session-data.js";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const MICROS_PER_MS = 1000;
const MAX_COOKIE_LENGTH = 3500;
let cached: GoogleSessionDetails | undefined;
let capturedUrl: string | undefined;
let mayRestore = true;

/** Withdrawals clear both cookie scopes used by the theme and Shopify app pixel. */
export function clearGoogleSession(): void {
  cached = undefined;
  capturedUrl = undefined;
  mayRestore = false;
  try {
    const removal = `${GOOGLE_SESSION_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    document.cookie = removal;
    const domain = cookieDomain();
    if (domain) document.cookie = `${removal}; domain=${domain}`;
  } catch { /* Cookie access can be unavailable; the in-memory copy stays cleared. */ }
}

/** Theme-owned custom rules receive the same observed context as native shop events. */
export function googleSessionForEvent(granted: boolean): GoogleSessionDetails | undefined {
  if (!granted) { clearGoogleSession(); return undefined; }
  const now = Date.now();
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("gad_source") || url.searchParams.has("gad_campaignid")) {
      if (capturedUrl === url.href) return parseGoogleSession(cached, now);
      cached = parseGoogleSession({gadSource:url.searchParams.get("gad_source"),gadCampaignId:url.searchParams.get("gad_campaignid"),
        sessionStartTimeMicros:String(now*MICROS_PER_MS),landingPageUserAgent:navigator.userAgent},now);
      capturedUrl = url.href;
      if (!cached) { clearGoogleSession(); return undefined; }
      const value = encodeURIComponent(JSON.stringify(cached));
      if (value.length <= MAX_COOKIE_LENGTH) setCookie(GOOGLE_SESSION_COOKIE,value,GOOGLE_SESSION_MAX_AGE_MS/MS_PER_DAY);
      return cached;
    }
    if (!cached && mayRestore) {
      const stored = getCookie(GOOGLE_SESSION_COOKIE);
      if (stored) cached = parseGoogleSession(JSON.parse(decodeURIComponent(stored)),now);
    }
  } catch { /* Optional session context must never prevent the event itself. */ }
  return parseGoogleSession(cached,now);
}
